import React, { Component } from 'react';
import {
  Row, Col, Checkbox, Form, Tree, Input,
} from 'antd';
import { formPropType } from 'utils/propType';
import { FormControl } from 'form-control';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { PROFILE_STEP_TYPES } from 'app/constants';
import AgentProfilePropType from '../AgentProfilePropType';
import WizardNav from './WizardNav';

import './Coverage.scss';

const { TreeNode } = Tree;
const CheckboxGroup = Checkbox.Group;

export class CoverageComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
    this.state = {
      selectedZipCodes: [],
    };
  }

  componentWillMount() {
    if (
      this.props.agentProfile.regionCoverage.zipCodes.length > 0
      && this.state.selectedZipCodes.length === 0
    ) {
      this.setState({ selectedZipCodes: [...this.props.agentProfile.regionCoverage.zipCodes] });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (JSON.stringify(this.props.agentProfile.regionCoverage.zipCodes)
        !== JSON.stringify(nextProps.agentProfile.regionCoverage.zipCodes))
      || (
        nextProps.agentProfile.regionCoverage.zipCodes.length > 0
        && this.state.selectedZipCodes.length === 0
      )
    ) {
      this.setState({ selectedZipCodes: [...nextProps.agentProfile.regionCoverage.zipCodes] });
    }
  }

  onSubmit(nextPage) {
    const { form } = this.props;
    form.validateFieldsAndScroll((errors, values) => {
      if (!errors) {
        const { selectedZipCodes } = this.state;
        const payload = this.mapPayload(selectedZipCodes, values);
        this.props.onSaveRegionCoverageRequest(nextPage, payload);
      }
    });
  }

  onSelectZip(stateList = []) {
    this.setState({
      selectedZipCodes: stateList,
    });
  }

  mapPayload(selectedZipCodes = [], fieldValues = {}) {
    const { regionCoverage } = this.props.agentProfile;
    const filteredZipcodes = selectedZipCodes.filter(z => !z.match(/[a-zA-Z]/));

    const payload = {
      ...regionCoverage,
      ...fieldValues,
      mlsCoverage: true,
      zipCodes: [
        ...filteredZipcodes,
      ],
    };
    return payload;
  }

  render() {
    const { selectedZipCodes } = this.state;
    const { coverageList, regionCoverage, isCallInprogress } = this.props.agentProfile;

    const inspectionTimeOptions = [
      { label: 'Morning', value: 'MORNING' },
      { label: 'Afternoon', value: 'AFTERNOON' },
      { label: 'Evening', value: 'EVENING' },
    ];

    const { form } = this.props;
    return (
      <div className="coverage">
        <Form layout="vertical">
          <div
            className="card-container responsive-border"
          >
            <h2 className="orange-text">{this.t('Coverage.area')}</h2>
            <p className="emphasized-text">
              {this.t('Coverage.selectZip')}
            </p>
            <Tree
              checkedKeys={[...selectedZipCodes]}
              checkable
              onCheck={this.onSelectZip}
            >
              {coverageList.map(st => (
                st.children.map(ct => (
                  <TreeNode
                    style={{ borderRadius: 4 }}
                    className="border"
                    title={<span className="margin-padding-zero capitalize">{st.name} / {ct.name}</span>}
                    key={ct.key}
                  >
                    {ct.children.map((c, index) => (
                      <TreeNode
                        className={(index < ct.children.length - 1) ? 'border-b' : ''}
                        title={<h3 className="medium-text capitalize inline">{c.name}</h3>}
                        key={c.key}

                      >
                        {c.zipCodes.map(zc => (
                          <TreeNode title={zc} key={zc} value={zc} isLeaf className="inline-block" />
                        ))}
                      </TreeNode>
                    ))}
                  </TreeNode>
                ))
              ))}
            </Tree>

            <div>
              <FormControl
                form={form}
                fieldName="additionalAreas"
                displayName={this.t('Coverage.additionalAreas')}
                initialValue={regionCoverage.additionalAreas}
              >
                <Input
                  maxLength={100}
                  autoComplete="off"
                  placeholder={this.t('Coverage.additionalAreas')}
                />
              </FormControl>
            </div>
          </div>
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('Coverage.schedule')}</h2>
            <p className="emphasized-text">{this.t('Coverage.whenComplete')}</p>
            <Row
              gutter={16}
              id="week"
            >
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.sundayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.sunday',
                    { initialValue: regionCoverage.typicalCompletion.sunday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.mondayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.monday',
                    { initialValue: regionCoverage.typicalCompletion.monday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.tuesdayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.tuesday',
                    { initialValue: regionCoverage.typicalCompletion.tuesday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.wednesdayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.wednesday',
                    { initialValue: regionCoverage.typicalCompletion.wednesday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.thursdayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.thursday',
                    { initialValue: regionCoverage.typicalCompletion.thursday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.fridayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.friday',
                    { initialValue: regionCoverage.typicalCompletion.friday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
              <Col lg={24} xl={3} className="weekday">
                <Form.Item label={this.t('Coverage.days.saturdayTimes')}>
                  {form.getFieldDecorator(
                    'typicalCompletion.saturday',
                    { initialValue: regionCoverage.typicalCompletion.saturday },
                  )(<CheckboxGroup options={inspectionTimeOptions} />)}
                </Form.Item>
              </Col>
            </Row>
          </div>
          <WizardNav
            agentProfile={this.props.agentProfile}
            isCallInProgress={isCallInprogress}
            currentPage={PROFILE_STEP_TYPES.COVERAGE}
            onNavigate={this.onSubmit}
          />
        </Form>
      </div>
    );
  }
}

CoverageComponent.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  onSaveRegionCoverageRequest: PropTypes.func.isRequired,
};

export default Form.create()(CoverageComponent);
